/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { connect } from 'react-redux';
import { TableCell, TableRow } from '@material-ui/core';
import EditButton from '../../../components/Buttons/EditButton';
import { history } from '../../../core/history';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import DeleteButton from '../../../components/Buttons/DeleteButton';
import OPL_STYLE from '../../../assets/themes/OPL/OplStyle';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';

interface FractionListItemProps {
    dispatch: any;
    classes: any;
    item: any;
    activeRow: number | null;

    setActiveRow(id: number): void;

    deleteFraction(param: { id: number }): void;
}

class FractionListItem extends PureComponent<FractionListItemProps> {
    editButton = (fraction: { uri: string }, event: any): void => {
        let uri = FormGeneralHelper.getRouteUrl('/fraction-edit' + fraction.uri);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, uri);
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, item, activeRow, setActiveRow, deleteFraction } = this.props;
        const tableCellRoot = { root: classes.tableCellRoot };
        const tableRowRoot = { root: classes.tableRowRoot };
        const tableCellSticky = { root: classes.tableControlSticky };

        let rowActiveColor = 'white';
        if (activeRow === item.id) {
            rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
        }
        return (
            <TableRow
                style={{ backgroundColor: rowActiveColor }}
                classes={tableRowRoot}
                hover={true}
                onClick={(): void => {
                    setActiveRow(item.id);
                }}
            >
                <TableCell style={{ backgroundColor: rowActiveColor }} align="left" classes={tableCellSticky}>
                    {<EditButton callback={this.editButton} callbackParam={{ uri: item['@id'] }} key={'edit' + item.id} />}
                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_FRACTION_DELETE) && (
                        <DeleteButton tooltipTitle="fractions:b.delete" callback={deleteFraction} callbackParam={{ id: item.id }} />
                    )}
                </TableCell>
                <TableCell classes={tableCellRoot} align="left">
                    {item.mainname}
                </TableCell>
            </TableRow>
        );
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(oplAppStyle))(FractionListItem);
